// extracted by mini-css-extract-plugin
export default {"accountName":"OrganizationsInvitationsReceivedItemMessage_accountName__mDUx8"};